import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import tag services
import { getTags, postTag, putTag, deleteTag } from '../../services/tag'

const getCurrentUser = state => state.user

export function* fetchTagx() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getTags(user.token))
    yield put({
      type: actions.FETCH_TAGX_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_TAGX_ERROR, message: error.message })
  }
}

export function* setTagx(tag) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    tag.payload.deviceMaster = JSON.parse(tag.payload.deviceMaster)
    tag.payload.deviceId = tag.payload.deviceMaster.deviceId
    tag.payload.deviceUid = tag.payload.deviceMaster.deviceUid

    // ajusta los json
    tag.payload.datetimedatajson = JSON.parse(tag.payload.datetimedatajson)
    tag.payload.sysdatajson = JSON.parse(tag.payload.sysdatajson)
    tag.payload.extradatajson = JSON.parse(tag.payload.extradatajson)
    tag.payload.operdatajson = JSON.parse(tag.payload.operdatajson)
    tag.payload.details = JSON.parse(tag.payload.details)

    // agrego la empresa a sysdatajson
    tag.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => putTag(user.token, tag.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_TAGX,
    })
  } catch (error) {
    yield put({ type: actions.TAGX_ERROR, message: error.message })
  }
}

export function* addTagx(tag) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    console.log('payload', tag.payload)
    tag.payload.deviceMaster = JSON.parse(tag.payload.deviceMaster)
    tag.payload.deviceId = tag.payload.deviceMaster.deviceId
    tag.payload.deviceUid = tag.payload.deviceMaster.deviceUid

    // ajusta los json
    tag.payload.sysdatajson = {}

    // agrego la empresa a sysdatajson
    tag.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => postTag(user.token, tag.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el registro',
    })
    yield put({
      type: actions.FETCH_TAGX,
    })
  } catch (error) {
    yield put({ type: actions.TAGX_ERROR, message: error.message })
  }
}

export function* delTagx(tag) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteTag(user.token, tag.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el registro',
    })
    yield put({
      type: actions.FETCH_TAGX,
    })
  } catch (error) {
    yield put({ type: actions.TAGX_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_TAGX, fetchTagx),
    takeEvery(actions.TAGX_SET, setTagx),
    takeEvery(actions.TAGX_ADD, addTagx),
    takeEvery(actions.TAGX_DEL, delTagx),
  ])
}
